import React from "react";
import PropTypes from "prop-types";

// Modern Imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";

const HeaderMetric = ({ id, text, metric, onClick }) => {
    return (
        <>
            <Grid item key={id} onClick={onClick} sx={onClick && { cursor: "pointer" }}>
                <Grid container direction="column" sx={{ marginLeft: 0.25, marginRight: 0.25 }}>
                    <Grid item>
                        <Typography id={id} align="center" component="div" variant="caption">
                            {metric}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography align="center" component="div" variant="caption">
                            {text}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

HeaderMetric.propTypes = {
    id: PropTypes.string,
    text: PropTypes.string,
    metric: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func
};

export default HeaderMetric;
